module.exports = __webpack_public_path__ + "assets/images/book_03c79962159c9bd16c9f17fcf3caee41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/locales/norte/book.png
// module id = 205
// module chunks = 0